angular.module('leanlaw').controller('SummaryChargesController', ['$scope', '$q', 'alerts', '$filter', "$timeout", "reportsService", "exportJson", "singleRequest", function ($scope, $q, alerts, $filter, $timeout, reportsService, exportJson, singleRequest) {
  $scope.activities = [{}];
  $scope.sort = 'date';
  $scope.reverse = false;

  // $scope.filter is owned by sidebar

  $scope.loading = true;
  function load() {
    if ($scope.activeTab != "charges") return;
    var query = queryFromFilter();
    if (!query) return;
    query.billed = 'any';
    query.billedState = undefined;
    $scope.loading = true;
    singleRequest.apiCall("tabdetail-charges").listCharges(query).then(list => {
      if (!list) return;
      $scope.charges = list.charges;
      $scope.total = list.charges.reduce((sum, e) => sum + e.amount, 0);
      $scope.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    var query = reportsService.queryFromFilter($scope.filter);
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.export = function () {
    const exp = $scope.charges.map(a => ({
      "Date": $filter("dateLogical")(a.date),
      "Description": a.description,
      "User": a?.account?.initials || a?.account?.name,
      "Matter": a.matter ? a.matter.label || a.matter.name : '',
      "Amount": $filter("amount")(a.amount)
    }));
    exportJson.downloadCsv(exp);
  };
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    load();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    load();
  });

  // Suffix is the active tab name for this view
  $scope.$on("summary-export-charges", payload => {
    $scope.export();
  });
  $scope.$watch("cm", newValue => {
    load();
  });
  $scope.$watch("activeTab", newValue => {
    $timeout(load);
  });
}]);